import { SpecialSectionId } from "features/Home/hooks/useHardcodedVR";

export const specialSectionRoute = {
  path: `/viewing-room/${SpecialSectionId}`
};